import { CloseOutlined } from '@ant-design/icons'
import { Modal, Space } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import ViewDetailedPurchaseIncomingModal from './detailedPurchaseIncoming'
import LandedCostsByPurchase from './landedCosts'
import PurchaseIncomingModal from './purchaseIncoming'
import ViewPurchaseIncomingModal from './view'

const PurchaseIncomingTab = ({
	visible,
	data,
	onClose,
	incoming = false,
	finishSale = false,
	ship = false,
	changeStatus = false,
	showPayment = false,
	isShowIncomingTab = true,
	isShowLandedCostTab = false,
	isShowLandedCosts = false,
	isShowPriceAtWhs = false,
	refetch,
	isShowDocRate = false,
}) => {
	const { roleNames } = useSelector((state) => state.main)

	const renderContent = () => {
		switch (activeTab) {
			case 'tab4':
				return (
					<ViewDetailedPurchaseIncomingModal
						data={data}
						refetch={refetch}
						isShowLandedCostTab={isShowLandedCostTab}
						isShowLandedCosts={isShowLandedCosts}
					/>
				)

			case 'tab5':
				return (
					<LandedCostsByPurchase
						data={data}
						finishSale={finishSale}
						ship={ship}
						incoming={incoming}
						changeStatus={changeStatus}
						showPayment={showPayment}
						refetch={refetch}
						onClose={onCloseModal}
					/>
				)

			default:
				return null
		}
	}
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('tab4')

	const onCloseModal = () => {
		onClose()
		setActiveTab('tab4')
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('purchaseIncomingNo')} № {data?.docNumPrefix}
				</h1>
			}
			open={visible}
			onCancel={onCloseModal}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="90%"
		>
			<Space style={{ marginBottom: 16 }} className="mt-5">
				<button
					className={`${
						activeTab === 'tab4'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold `}
					onClick={() => setActiveTab('tab4')}
				>
					{t('detailed')}
				</button>

				{isShowLandedCostTab && (
					<button
						className={`${
							activeTab === 'tab5'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold ml-3`}
						onClick={() => setActiveTab('tab5')}
					>
						{t('landedCost')}
					</button>
				)}
			</Space>
			<div className="mt-5">{renderContent()}</div>
		</Modal>
	)
}

export default PurchaseIncomingTab
